import { Maybe, Scalars } from 'types/graphqlTypes'
import { TFilters } from '../PageList'

export type TCurrentFiltersWithPagination<Filters> = Partial<Filters> & {
  after?: Maybe<Scalars['String']>
  before?: Maybe<Scalars['String']>
  first?: Maybe<Scalars['Int']>
  last?: Maybe<Scalars['Int']>
}

interface IPageChangeHandlerArgs<Filters> {
  /**
   * Start cursor from GQL PageInfo object
   */
  startCursor: Maybe<string>
  /**
   * End cursor from GQL PageInfo object
   */
  endCursor: Maybe<string>
  /**
   * Fn that sets the variables used in the Graphql query or refreshes the query
   */
  setCurrentFilters: (filters: TCurrentFiltersWithPagination<Filters>) => void
  /**
   * Number of items to be returned from Graphql query
   */
  itemsPerPage: number
  setPageNumber?: (pageNumber: number) => void
}

export const pageChangeHandler = <Filters>({
  endCursor,
  itemsPerPage,
  setCurrentFilters,
  setPageNumber,
  startCursor,
}: IPageChangeHandlerArgs<Filters>) => (
  isNext: boolean,
  filters: Partial<TFilters<Filters>>,
  pageNumber: number
) => {
  if (setPageNumber) setPageNumber(pageNumber)
  if (isNext) {
    setCurrentFilters({
      ...filters,
      after: endCursor,
      before: undefined,
      first: itemsPerPage,
      last: undefined,
    })
  } else {
    setCurrentFilters({
      ...filters,
      after: undefined,
      before: startCursor,
      first: null,
      last: itemsPerPage,
    })
  }
}

/**
 * The connection strategy that the backend uses the base 64 encryption to generate the cursors,
 * so taking advantage of this, we can create the cursor to send to the BE
 */
export const pageNumeratedChangeHandler = <Filters>({
  itemsPerPage,
  setCurrentFilters,
  setPageNumber,
}: Pick<
  IPageChangeHandlerArgs<Filters>,
  'itemsPerPage' | 'setCurrentFilters' | 'setPageNumber'
>) => (isNext: boolean, filters: Partial<TFilters<Filters>>, pageNumber: number) => {
  if (setPageNumber) setPageNumber(pageNumber)
  setCurrentFilters({
    ...filters,
    after: btoa(`${(pageNumber - 1) * itemsPerPage}`),
    before: undefined,
    first: itemsPerPage,
    last: undefined,
  })
}
